// extracted by mini-css-extract-plugin
export default {"gallery":"home_gallery__j3jeL","imgSquare":"home_imgSquare__lldvX"};